<template>
  <div class="home">
    
    <ResumenSignature/>
    
  </div>
</template>

<script>
// @ is an alias to /src
import ResumenSignature from '@/components/ResumenSignature.vue'

export default {
  name: 'resumenParte',
  components: {
    ResumenSignature,
  }
}
</script>
<style scoped>
.home{
  height: 100%;
}
.fc{
  height: 100%;
}
</style>
